import React, { useContext, useEffect, useRef, useState } from "react";
import { $ } from "react-jquery-plugin";
import { NavLink } from "react-router-dom";
import { scrollToTop } from "../../services/helper";

const Sidebar = () => {
  const [showMenu, setShowMenu] = useState(false);

  const onToggleHandler = () => {
    setShowMenu(!showMenu);
    $(".main-content").toggleClass("slide-content");
  };

  const sideBarRef = useRef(null);
  useEffect(() => {
    $(".navToggler").on("click", function () {
      $(".main-content").toggleClass("slide-content");
      $(".nav-wrap").toggleClass("show-menu");
      $(".inner-nav").toggleClass("show");
      $(".nav-menu").toggle();
    });
    const handleClickOutside = (event) => {
      if (sideBarRef.current && !sideBarRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <React.Fragment>
      <div className="site-navigation" ref={sideBarRef}>
        <div className="button-wrap" onClick={onToggleHandler}>
          <button id="btn-toogle" className="btn-toggle navToggler">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div className={`nav-wrap ${showMenu ? "show-menu" : ""}`}>
          <div className="inner-nav">
            <ul
              className={`nav-menu  ${showMenu ? "d-block" : "d-none"}`}
              id="nav-menu"
            >
              <li className="nav-item">
                <NavLink
                  onClick={() => {
                    scrollToTop();
                  }}
                  to="/home"
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={() => {
                    scrollToTop();
                  }}
                  to="/skills"
                >
                  Skills
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={() => {
                    scrollToTop();
                  }}
                  to="/project"
                >
                  Projects
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={() => {
                    scrollToTop();
                  }}
                  to="/contact"
                >
                  Contact
                </NavLink>
              </li>
              <li className="nav-item">
                {" "}
                <NavLink
                  onClick={() => {
                    scrollToTop();
                  }}
                  to="/admin/login"
                >
                  Login
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
//named exports
export { Sidebar };
